import React from 'react'
import "./QuoteWaitingModal.css"

const QuoteWaitingModal = (props) => {
   
    return (
        <div className='quotewaitmodal' >
            <div className="content">
                Please give it a moment for all quotes to load.
            </div>
            <div className="okdiv">
                <button onClick={props.close} >Okay</button>
            </div>
        </div>
    )
}

export default QuoteWaitingModal